// extracted by mini-css-extract-plugin
export default {"tabsHeader":"RulesTabs_tabsHeader__QgOhs","tabsContent":"RulesTabs_tabsContent__C-mxo","tabContent":"RulesTabs_tabContent__Bwhoc"};